<template>
    <Paper class="corporateIdentify">
        <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="21">
                <el-row>
                    <el-col class="corporateIdentify-item">
                        <span class="corporateIdentify-select EnterpriseKey">
                            <el-select
                                v-model="serarchData.enterpriseData"
                                filterable remote multiple
                                collapse-tags
                                :multiple-limit="10"
                                reserve-keyword
                                @focus="searchDataChange"
                                placeholder="请输入关键词搜索"
                                :remote-method="remoteMethod"
                            >
                                <el-option
                                    v-for="item in enterpriseOptions"
                                    :key="item.prefixCode"
                                    :label="item.cnName"
                                    :value="item.prefixCode">
                                </el-option>
                            </el-select>
                        </span>
                    </el-col>
                    <el-col class="corporateIdentify-item">
                        <span class="corporateIdentify-select">
                            <el-date-picker
                                v-model="serarchData.date"
                                type="daterange"
                                align="left"
                                value-format='yyyy-MM-dd HH:mm:ss'
                                :default-time="['00:00:00', '23:59:59']"
                                unlink-panels
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="mini"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </span>
                    </el-col>
                    <div>
                        <el-button @click="corporateIdentifySearch" type="primary"  size="mini" icon='el-icon-search'>
                            查 询
                        </el-button>
                    </div>
                </el-row>
            </el-col>

            <!-- <el-col class="corporateIdentify-item">
                <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col  :span="14">
                        <div>
                            <span class="corporateIdentify-text" style="margin-right: 10px;">
                                查询日期:
                            </span>
                            <span class="corporateIdentify-select">
                                <el-date-picker
                                    v-model="serarchData.date"
                                    type="daterange"
                                    align="left"
                                    value-format='yyyy-MM-dd HH:mm:ss'
                                    :default-time="['00:00:00', '23:59:59']"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    size="mini"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </span>
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <div class="corporateButton">
                            <el-button @click="corporateIdentifySearch" type="primary">查 询</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-col> -->
        </el-row>
        <div class="corporateIdentify-echart">
            <div v-if="!showtrue" class="showHint">暂无数据</div>
            <report-echart
                v-if="showtrue"
                :ecahrtID="corporateIdentifyEchart"
                :titleText="titleText"
                :maxNumber="maxNumber"
                :XAxisData="XAxisData"
                :seriseData="seriseData"
                :legendData="legendData">
            </report-echart>
            <div class="ecahrt-unit">单位: 次/日</div>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import ReportEchart from '../../../components/reportEchart/Index';
import { getEnterprise, getAnalysisIdentifyingNumber, arrmax } from '../../../api/reportManagement';
export default {
    name: 'corporateIdentify',
    components: { Paper, ReportEchart },
    data() {
        return {
            corporateIdentifyEchart: 'corporateIdentifyEchart',
            serarchData: {
                enterpriseData: [],
                date: []
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const start = new Date();
                            start.setHours(0);
                            start.setMinutes(0);
                            start.setSeconds(0);
                            const end = new Date();
                            end.setHours(23);
                            end.setMinutes(59);
                            end.setSeconds(59);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const start = new Date();
                            start.setHours(0);
                            start.setMinutes(0);
                            start.setSeconds(0);
                            const end = new Date();
                            end.setHours(23);
                            end.setMinutes(59);
                            end.setSeconds(59);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const start = new Date();
                            start.setHours(0);
                            start.setMinutes(0);
                            start.setSeconds(0);
                            const end = new Date();
                            end.setHours(23);
                            end.setMinutes(59);
                            end.setSeconds(59);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            enterpriseOptions: [],
            titleText: '企业标识对比图',
            XAxisData: [],
            showtrue: false,
            seriseData: [
                {
                    name: '解析量',
                    type: 'bar',
                    data: [],
                    barWidth: '20px',
                    itemStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#8ECFFF' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#AFF0F1' // 100% 处的颜色
                            }], false)
                        }
                    }
                }, {
                    name: '标识数量',
                    type: 'bar',
                    data: [],
                    barWidth: '20px',
                    itemStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#FFAE8E' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#F1D1AF' // 100% 处的颜色
                            }], false)
                        }
                    }
                }
            ],
            legendData: ['解析量', '标识数量'],
            maxNumber: 0
        };
    },
    methods: {
        searchDataChange() {
            this.remoteMethod();
        },
        remoteMethod(query) {
            const params = {
                cnName: query,
                pageSize: 10
            };
            getEnterprise(params).then(res => {
                if (+res.code === 0) {
                    if (query) {
                        this.enterpriseOptions = res.data.list.filter(item => {
                            return item.cnName.toLowerCase().indexOf(query.toLowerCase()) > -1;
                        });
                    } else {
                        this.enterpriseOptions = res.data.list;
                    }
                };
            });
        },
        corporateIdentifySearch() {
            const params = {};
            if (this.serarchData.enterpriseData.length) {
                params['prefixCode'] = this.serarchData.enterpriseData.join(',');
            } else {
                this.$message.warning('请选择你的企业前缀');
                return;
            }
            if (this.serarchData.date.length) {
                params['startTime'] = this.serarchData.date[0];
                params['endTime'] = this.serarchData.date[1];
            } else {
                this.$message.warning('请选择查询时间');
                return;
            }
            getAnalysisIdentifyingNumber(params).then(res => {
                if (+res.code === 0 && res.data.length) {
                    const XAxis = [];
                    const registryData = [];
                    const analyzeData = [];
                    res.data.map(item => {
                        XAxis.push(item[0].enterpriseName);
                        item.map(val => {
                            if (val.action === 'registry') {
                                registryData.push(val.count);
                            };
                            if (val.action === 'parse') {
                                analyzeData.push(val.count);
                            }
                        });
                    });
                    const maxData = analyzeData.concat(registryData);
                    this.maxNumber = arrmax(maxData);
                    this.XAxisData = XAxis;
                    this.seriseData[0].data = analyzeData;
                    this.seriseData[1].data = registryData;
                    this.showtrue = true;
                } else {
                    this.showtrue = false;
                }
            });
        }
    }
};
</script>
<style lang="less">
.corporateIdentify {
    overflow: auto;
    .corporateIdentify-item{
        width: 190px;
        margin-right: 10px;
    }
    .corporateIdentify-text,.corporateIdentify-dat {
        font-size: 14px;
        color: rgba(0,0,0,0.85);
    }
    .corporateIdentify-select {
        width: 100%;
        display: inline-block;
        .el-select {
            width: 100%;
        }
        .el-range-editor--mini.el-input__inner {
            width: 100%;
            .el-range__icon {
                display: none;
            }
        }

    }
    .EnterpriseKey {
        position: relative;
        .el-input__inner {
            padding: 0 15px !important;
        }
        .changSeclt-icon {
            position: absolute;
            height: 100%;
            width: 20px;
            top: 6px;
            right: 0;
        }
    }
    .corporateIdentify-echart {
        margin-top: 20px;
        height: calc(100vh - 10vw - 20px);
        position: relative;
        .ecahrt-unit {
            position: absolute;
            top: 20px;
            right: 2vw;
            font-size: 14px;
            color: rgba(0,0,0,0.45);
        }
    }
    #corporateIdentifyEchart{
        height: 100%;
        width: 100%;
    }
    .showHint {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #898c8c;
    }
    .corporateButton {
        display: flex;
        justify-content: flex-end;
        padding-right: 40px;
    }
}
</style>